import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import * as MapView from 'esri/views/MapView';
import BasemapGallery from 'esri/widgets/BasemapGallery';
import PortalBasemapsSource from 'esri/widgets/BasemapGallery/support/PortalBasemapsSource';
import Expand from 'esri/widgets/Expand';
import Search from 'esri/widgets/Search';

import esri = __esri;

export type Widget = 'search' | 'map-gallery';
@Injectable({
  providedIn: 'root'
})
export class WidgetService {
  renderer: Renderer2;

  defaultWedgets: Widget[] = ['map-gallery'];

  mapsTitles: String[] = [
    'Topographic',
    'Streets',
    'Streets (Night)',
    'OpenStreetMap',
    'Imagery with Labels',
    'Imagery',
    'Imagery Hybrid',
    'Light Gray Canvas',
    'Dark Gray Canvas',
    'Terrain with Labels'
  ];

  basemapTitleMap: Map<string, string> = new Map([
    ['Imagery', 'satellite'],
    ['Imagery Hybrid', 'hybrid'],
    ['Imagery with Labels', 'hybrid'],
    ['Streets', 'streets-vector'],
    ['Topographic', 'topo-vector'],
    ['Streets (Night)', 'streets-night-vector'],
    ['World Street Map (Night)', 'streets-night-vector'],
    ['Terrain with Labels', 'terrain'],
    ['Light Gray Canvas', 'gray-vector'],
    ['Dark Gray Canvas', 'dark-gray-vector'],
    ['OpenStreetMap', 'osm'],
  ]);

  constructor(
    private rendererFactory: RendererFactory2,
  ) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  initializeWidgets(view: MapView, widgets: Widget[] = this.defaultWedgets) {
    widgets.forEach((widget: Widget) => {
      switch (widget) {
        case 'search':
          this.createSearchWidget(view);
          break;
        case 'map-gallery':
          this.createBasemapGalleryWithExpand(view);
          break;
      }
    });
  }

  createBasemapGalleryWithExpand(view: MapView) {

    const source = new PortalBasemapsSource({
      query: {
        title: 'United States Basemaps',
        owner: 'Esri_cy_US'
      },
      filterFunction: (map: any) => {
        /**
         * You can filter maps passed back from the default portal (duplicated above) by the
         * portalItem values.
         */
        return this.mapsTitles.indexOf(map.portalItem.title) !== -1;

      }
    });
    const basemapGallery = new BasemapGallery({
      view,
      container: this.renderer.createElement('div'),
      source
    });
    basemapGallery.watch('activeBasemap', (newBasemap) => {
      localStorage.setItem('lastBasemap', this.basemapTitleMapper(newBasemap.title));
    });
    // Create an Expand instance and set the content
    // property to the DOM node of the basemap gallery widget

    const expandProperties: esri.ExpandProperties = {
      view,
      content: basemapGallery,
      expanded: true,
      autoCollapse: true,
      group: 'all'
    };
    const bgExpand = new Expand(expandProperties);
    view.ui.add(bgExpand, 'top-trailing');
  }

  basemapTitleMapper(title: string): string {
    return this.basemapTitleMap.get(title) || 'topo-vector';
  }

  createSearchWidget(view: MapView) {

    const searchWidget = new Search({
      view
    });

    // Add the search widget to the top right corner of the view
    view.ui.add(searchWidget, {
      position: 'top-right'
    } as esri.UIAddPosition);
  }
}
